import React from 'react';
import Switch from 'react-switch';

import {
  CheckboxHours,
  DateInput,
  Icon,
  IconButton,
  TimeInputHours,
} from '../../components/common';
import {
  H3,
  Content,
  Div,
  CardDay,
  DivTitle,
  H4,
  SpanTitle,
  Span,
  HourWrapper,
  Hour,
  FieldWrapper,
  ButtonClose,
  DivButton,
  NewProductButton,
  HourWrapperExceptions,
  CheckboxWrapper,
  DateFieldWrapper,
} from './style';

const weekNames = {
  0: 'Domingo',
  1: 'Segunda',
  2: 'Terça',
  3: 'Quarta',
  4: 'Quinta',
  5: 'Sexta',
  6: 'Sábado',
};

const StoreHours = ({
  openingHoursDelivery,
  exceptionsHoursDelivery,
  handleFrom,
  handleTo,
  handleCloseNewHourMonday,
  handleAddNewHour,
  operatingDays,
  exceptionDays,
  ...propsDayWeekDelivery
}) => {
  const {
    handleOperatingDaysEnabledChange,
    handleOperatingDayTimeChange,
    handleAddOperatingDayTime,
    handleRemoveOperatingDayTime,
    handleAddExceptionDay,
    handleRemoveExceptionDay,
    handleUpdateExceptionDay,
  } = propsDayWeekDelivery;

  return (
    <>
      {
        <Div>
          {operatingDays.map((operatingDay, dayIndex) => (
            <Content key={dayIndex}>
              <Div>
                <CardDay>
                  <DivTitle>
                    <H4>{weekNames[dayIndex]}</H4>
                    <Switch
                      onChange={(enabled) =>
                        handleOperatingDaysEnabledChange({ dayIndex, enabled })
                      }
                      checked={operatingDay.enabled}
                      height={12}
                      width={25}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      onColor={'#173A6D'}
                    />
                    <SpanTitle>{operatingDay.enabled ? 'Aberto' : 'Fechado'}</SpanTitle>
                  </DivTitle>
                  <HourWrapper>
                    {operatingDay.hours.map((hour, hourIndex) => {
                      return (
                        <Hour key={hour.id} className={operatingDay.enabled ? '' : 'disabled'}>
                          <SpanTitle>Horário {hourIndex + 1}</SpanTitle>
                          <FieldWrapper>
                            <TimeInputHours
                              disabled={!operatingDay.enabled}
                              day={dayIndex}
                              index={hour.id}
                              value={hour.start}
                              onChange={({ e }) =>
                                handleOperatingDayTimeChange({
                                  dayIndex,
                                  hourId: hour.id,
                                  start: e.target.value,
                                  end: hour.end,
                                })
                              }
                            />
                          </FieldWrapper>
                          <Span>às</Span>
                          <FieldWrapper>
                            <TimeInputHours
                              disabled={!operatingDay.enabled}
                              day={dayIndex}
                              index={hour.id}
                              value={hour.end}
                              onChange={({ e }) =>
                                handleOperatingDayTimeChange({
                                  dayIndex,
                                  hourId: hour.id,
                                  end: e.target.value,
                                  start: hour.start,
                                })
                              }
                            />
                          </FieldWrapper>
                          <ButtonClose>
                            <IconButton
                              icon={'close'}
                              onClick={() =>
                                handleRemoveOperatingDayTime({
                                  dayIndex,
                                  hourId: hour.id,
                                })
                              }
                              title={`Excluir`}
                            />
                          </ButtonClose>
                        </Hour>
                      );
                    })}
                    <DivButton>
                      <NewProductButton
                        disabled={!operatingDay.enabled}
                        className="primary"
                        onClick={() =>
                          handleAddOperatingDayTime({
                            dayIndex,
                          })
                        }
                      >
                        <Icon name="plus" /> Adicionar Horário
                      </NewProductButton>
                    </DivButton>
                  </HourWrapper>
                </CardDay>
              </Div>
            </Content>
          ))}
          <H3>Agendar exceção para loja fechada.</H3>
          <Content>
            <Div className="exception">
              <CardDay>
                <HourWrapperExceptions>
                  {exceptionDays.map((exceptionDay) => (
                    <Hour
                      key={exceptionDay.id}
                      className={exceptionDay.close ? 'exception disabled' : 'exception'}
                    >
                      <Content>
                        <SpanTitle>Data</SpanTitle>
                        <DateFieldWrapper>
                          <DateInput
                            disabled={exceptionDay.isClosedAllDay}
                            value={exceptionDay.date}
                            width={'120px'}
                            onChange={(date) =>
                              handleUpdateExceptionDay({
                                exceptionDayId: exceptionDay.id,
                                exceptionDay: { ...exceptionDay, date },
                              })
                            }
                          />
                        </DateFieldWrapper>
                      </Content>
                      <Content>
                        <SpanTitle>Horario</SpanTitle>
                        <FieldWrapper>
                          <TimeInputHours
                            disabled={exceptionDay.isClosedAllDay}
                            value={exceptionDay.startHour}
                            index={exceptionDay.id}
                            onChange={({ e }) =>
                              handleUpdateExceptionDay({
                                exceptionDayId: exceptionDay.id,
                                exceptionDay: { ...exceptionDay, startHour: e.target.value },
                              })
                            }
                          />
                        </FieldWrapper>
                        <Span>às</Span>
                        <FieldWrapper>
                          <TimeInputHours
                            disabled={exceptionDay.isClosedAllDay}
                            value={exceptionDay.endHour}
                            index={exceptionDay.id}
                            onChange={({ e }) =>
                              handleUpdateExceptionDay({
                                exceptionDayId: exceptionDay.id,
                                exceptionDay: { ...exceptionDay, endHour: e.target.value },
                              })
                            }
                          />
                        </FieldWrapper>
                      </Content>
                      <CheckboxWrapper>
                        <CheckboxHours
                          index={exceptionDay.id}
                          checked={exceptionDay.isClosedAllDay}
                          onCheck={({ checked }) =>
                            handleUpdateExceptionDay({
                              exceptionDayId: exceptionDay.id,
                              exceptionDay: checked
                                ? {
                                    ...exceptionDay,
                                    isClosedAllDay: checked,
                                    startHour: '00:00',
                                    endHour: '23:59',
                                  }
                                : { ...exceptionDay, isClosedAllDay: checked },
                            })
                          }
                        >
                          Fechado o dia todo
                        </CheckboxHours>
                      </CheckboxWrapper>
                      <ButtonClose>
                        <IconButton
                          icon={'close'}
                          onClick={() =>
                            handleRemoveExceptionDay({ exceptionDayId: exceptionDay.id })
                          }
                          title={`Excluir`}
                        />
                      </ButtonClose>
                    </Hour>
                  ))}
                </HourWrapperExceptions>
                <DivButton>
                  <NewProductButton className="primary" onClick={handleAddExceptionDay}>
                    <Icon name="plus" /> Adicionar Horário
                  </NewProductButton>
                </DivButton>
              </CardDay>
            </Div>
          </Content>
        </Div>
      }
    </>
  );
};

export default StoreHours;
